import { IApiGetDemoDataParam, IApiGetPlaylistParam, IPlaylist } from '../interfaces/api';
import { call, delay, put, takeLatest } from 'redux-saga/effects';
import apis from './apis';
import actions from './actions';
import { AxiosResponse } from 'axios';
import { IDEMOModelResDataItem } from '../interfaces/demoData';
import { ISagaFunc } from 'services/actionConfigs';
import { setPageLoading } from 'widgets/PageLoading';
import { IResponseData } from 'services/response';
import { PaginationResponse } from 'services/commonTypes';

const getDemoData: ISagaFunc<IApiGetDemoDataParam> = function* () {
  try {
    const resData: AxiosResponse<{ data: IDEMOModelResDataItem[] }> = yield call(apis.getDemoData);
    if (resData?.data?.data) {
      yield put(actions.getDemoData.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getDemoData.fail({}));
  } finally {
  }
};

const getListPlaylists: ISagaFunc<IApiGetPlaylistParam> = function* ({ payload }) {
  setPageLoading(true);
  yield delay(200);
  try {
    const resData: IResponseData<PaginationResponse<IPlaylist>> = yield call(apis.getListPlaylists, payload);
    if (resData?.data?.data) {
      yield put(actions.getListPlaylists.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getListPlaylists.fail({}));
  } finally {
    setPageLoading(false);
  }
};

const setPlaylistsParam: ISagaFunc<IApiGetPlaylistParam> = function* ({ payload }) {
  yield put(actions.getListPlaylists.fetch(payload));
};

export default function* playlistServiceSagas() {
  yield takeLatest(actions.getDemoData.fetch, getDemoData);
  yield takeLatest(actions.getListPlaylists.fetch, getListPlaylists);
  yield takeLatest(actions.setPlaylistsParam, setPlaylistsParam);
}
